<template>
	<div></div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { getInfo } from "@/api/user"
	import RequestUtils from "@/utils/im/RequestUtils";
	import conf from "@/utils/im/index";
	import StoreUtils from "@/utils/im/StoreUtils";
	export default {
		name: 'im',
		data() {
			return {

			}
		},
		mounted() {
			this.getinfo();
		},
		methods: {
			getinfo() {
				var token = getStorageToken();
				if(token) {
					getInfo(token).then(res => {
						if(res.code == 'OK') {
							RequestUtils.getInstance().webSocketOperation(this);
						}
					})
				}
			},
		},
	}
</script>